import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { sortDepartments, filterVacanciesByCountryCode } from '../utils';
import { errorMessage } from '../../shared/utils';
import { PREFERRED_CAREER_COUNTRY_KEY } from '../../shared/config/constants';
import { getVacancies, localStorageGet } from '../../services';

const useGetVacancies = () => {
    const [vacancies, setVacancies] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const { t } = useTranslation('PayseraRecruitmentBundle');

    const getAllVacancies = async (countryCode) => {
        try {
            setIsLoading(true);
            const preferredCountry = countryCode || localStorageGet(PREFERRED_CAREER_COUNTRY_KEY);
            const response = await getVacancies(preferredCountry);
            const filteredVacancies = filterVacanciesByCountryCode(response?.data?.data, preferredCountry);

            setVacancies(sortDepartments(filteredVacancies));
        } catch (errors) {
            setError(t(errorMessage(errors)));
        } finally {
            setIsLoading(false);
        }
    };

    const handleCountryChange = (countryCode) => {
        setError(null);
        getAllVacancies(countryCode);
    };

    useEffect(() => {
        getAllVacancies();
    }, []);

    return {
        vacancies,
        isLoading,
        error,
        handleCountryChange,
    }
};

export default useGetVacancies;
